module.exports = __webpack_public_path__ + "img/car_6_mustang.93471989.jpg";